import React from 'react';
import '../styles/Icon.css';

const ICON_MAP = {
  'adjust': '\ue835',
  'angle-circled-down': '\uf13a',
  'angle-circled-left': '\uf137',
  'angle-circled-right': '\uf138',
  'angle-circled-up': '\uf139',
  'apple': '\uf179',
  'attach': '\ue822',
  'bell': '\ue82f',
  'bookmark': '\ue829',
  'bookmark-empty': '\uf097',
  'calendar-check-o': '\uf274',
  'calendar-minus-o': '\uf272',
  'calendar-plus-o': '\uf271',
  'calendar-times-o': '\uf273',
  'cancel': '\ue81e',
  'chart-area': '\uf1fe',
  'chart-bar': '\ue837',
  'check': '\ue836',
  'check-empty': '\uf096',
  'comment-empty': '\uf0e5',
  'commenting': '\uf27a',
  'doc': '\ue831',
  'down-open': '\ue800',
  'eye': '\ue825',
  'eye-off': '\ue826',
  'flag': '\ue82a',
  'flag-empty': '\uf11d',
  'forward': '\ue82d',
  'heart': '\ue807',
  'heart-empty': '\ue81a',
  'help': '\uf128',
  'home': '\ue81f',
  'info-circled': '\ue820',
  'instagram': '\uf16d',
  'arrow-forward': '\ue801',
  'calendar': '\ue802',
  'category-tag': '\ue805',
  'close-x': '\ue804',
  'dark-mode': '\ue809',
  'feeds': '\ue806',
  'go-to-link': '\ue808',
  'google-logo': '\ue80f',
  'lock': '\ue823',
  'log-out': '\ue80b',
  'login': '\ue80c',
  'notification-bell': '\ue80e',
  'pencil': '\ue82e',
  'plus-add': '\ue810',
  'search': '\ue812',
  'left-circle': '\uf0a8',
  'left-open': '\ue817',
  'left-open-mini': '\ue818',
  'linkedin': '\uf30c',
  'facebook': '\uf308',
  'link': '\ue821',
  'logout': '\ue832',
  'menu': '\ue81c',
  'minus-circled': '\uf056',
  'more': '\ue82d',
  'ok': '\ue81d',
  'pause': '\ue813',
  'picture': '\ue838',
  'pin': '\ue824',
  'play': '\ue814',
  'plus': '\ue810',
  'plus-circled': '\uf055',
  'right-circle': '\uf0a9',
  'right-open': '\ue818',
  'right-open-mini': '\ue81b',
  'server': '\uf233',
  'share': '\ue82a',
  'star': '\ue81b',
  'star-empty': '\ue81c',
  'tag': '\ue827',
  'tags': '\ue828',
  'tasks': '\uf0ae',
  'th-list': '\uf009',
  'trash-empty': '\ue830',
  'twitter': '\uf099',
  'upload-cloud': '\ue839',
  'user': '\ue816',
  'user-add': '\ue815',
  'warning': '\uf071',
  'youtube': '\uf167',
  'sources': '\ue814',
  'share-link': '\ue813',
  'arrow-backward': '\ue803',
  'paper-plane-empty': '\uf1d9',
  'lightbulb': '\ue83a',
  'building': '\uf0f7',
  'vkontakte-rect': '\uf30a',
  'magic': '\uf0d0',
  // New v3 icons
  'superadmin': '\ue83e',
  'clipboard': '\ue83f',
  'admin': '\ue840',
  'velvet': '\ue841',
  'ai': '\ue842',
  'docs': '\uf0c5',
  'doc-text': '\ue831',  // Alias for doc icon
  'google': '\ue80f',    // Alias for google-logo
  // Chevron aliases
  'chevron-down': '\ue800',
  'chevron-up': '\ue800',
  'chevron-left': '\ue817',
  'chevron-right': '\ue818',
  // Clock alias (using calendar icon as substitute)
  'clock': '\ue802',
  // Robot and refresh icons
  'robot': '\ue842',  // Using AI icon as robot substitute
  'refresh': '\ue800',  // Using down-open (circular arrow) as refresh
  // Microphone icon
  'mic': '\uf130',
  // Database backup icons
  'download': '\ue839',  // Using upload-cloud icon (same visual works for download)
  'database': '\uf233',  // Using server icon
  'upload': '\ue839',    // Using upload-cloud icon
  // Close alias
  'close': '\ue804',      // Alias for close-x
  // Unlink icon for disable/deactivate
  'unlink': '\uf127',
  // Gear/settings icon
  'gear': '\ue811',
  // New v4 icons
  'videocam': '\ue843',
  'picture-1': '\ue844',
  'camera': '\ue845',
  'mobile': '\ue846',
  'monitor': '\ue847',
  'align-left': '\ue848',
  'align-center': '\ue849',
  'align-right': '\ue84a',
  'align-justify': '\ue84b',
  'content': '\ue84c',
  'windows': '\uf17a',
  'slack': '\uf198'
};

const Icon = ({ name, className = '', size = '1em', style = {} }) => {
  const iconCode = ICON_MAP[name];

  if (!iconCode) {
    console.warn(`Icon "${name}" not found in icon map`);
    return null;
  }

  return (
    <i
      className={`vl-icon ${className}`}
      style={{ fontSize: size, ...style }}
      aria-hidden="true"
    >
      {iconCode}
    </i>
  );
};

export default Icon;
